import { render, staticRenderFns } from "./PriceAreaCard.vue?vue&type=template&id=0d0d434b"
import script from "./PriceAreaCard.vue?vue&type=script&lang=ts"
export * from "./PriceAreaCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports